

















































































































































































































































import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import {
  Mall,
  GetMallsContractedPartnersByMallNoRequest,
  GetOrderOptionsMallDelaySummaryRequest,
  getOrdersSearchTypesRequest,
  GetOrderOptionsNaverDelaySummaryRequest,
} from 'supporter';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import {MallsArrItem} from '@/types';
import ClickOutside from 'vue-click-outside';
import {getToday, addDay} from '@/utils/dateUtils';
import { ValueNameType } from '@/store/modules/orderEnums';
import {SelectBoxOption} from '@/types/order';

const orderEnumsModule = namespace('orderEnums');

@Component({
  components: {CompSelectBox, PageTitle, PeriodDateCalendar},
  directives: {
    ClickOutside
  }
})
export default class OrderContentTop extends Vue {
  @Prop({default: true, required: false})
  private showClaimType?: boolean;
  @Prop({default: true, required: false})
  private showOrderStatus?: boolean;
  @Prop({default: true, required: false})
  private showPayType?: boolean;
  @Prop({default: false, required: false})
  private showSearchDateType?: boolean;
  @Prop({default: false, required: false})
  private showReceiver?: boolean;
  @Prop({default: true, required: false})
  private showIncludeHoldDelivery?: boolean;
  @Prop({default: true, required: false})
  private showDeliveryType?: boolean;
  @Prop({default: undefined, required: false})
  private showCliamStatusType?: string;
  @Prop({default: false, required: false})
  private showReturnWayType?: boolean;
  @Prop({default: true, required: false})
  private showShippingAreaType?: boolean;
  @Prop({default: false, required: false})
  private showDelay?: boolean;
  @Prop({default: '', required: false})
  private delayOrderType?: any;
  @Prop({default: 'PAY_FAIL', required: false})
  private orderStatus?: any;
  @Prop({default: 'ORDERNO', required: false})
  private groupByKey?: any;
  @Prop({
    default: (): any => [
      {value: 'STATE_CHANGE_YMDT', name: 'ORDER_ORDER_CONTENT_TOP_LIST_STATE_CHANGE_YMDT'},
      {value: 'ORDER_YMDT', name: 'ORDER_ORDER_CONTENT_TOP_LIST_ORDER_YMDT'}
    ],
    required: false
  })
  private searchDateTypeArr?: any;

  @Prop({default: 'ORDER_ORDER_CONTENT_TOP_SEND_DELAY', required: false})
  private delayText?: string;
  @Prop({default: true, required: false})
  private showIncludeReservationYn?: boolean;
  @Prop({required: false})
  private orderStatusArr?: string[];
  @Prop({default: true, required: false})
  private showClaim?: boolean;
  @Prop({default: false, required: false})
  private includeHoldDelivery?: boolean;

  @Watch('getOrderOptionsOrderGrid.platformTypes.length', {immediate: false, deep: true})
  platformTypesLength(next: number) {
    this.checkAllCheck(next, this.initPlatformTypes.length, this, 'platformTypesCheckAll');
  }
  @Watch('getOrderOptionsOrderGrid.orderStatusTypes.length', {immediate: false, deep: true})
  orderStatusTypesLength(next: number) {
    this.checkAllCheck(next, this.initOrderStatusTypes.length, this, 'orderStatusTypesCheckAll');
  }
  @Watch('getOrderOptionsOrderGrid.payTypes.length', {immediate: false, deep: true})
  payTypesLength(next: number) {
    if (next) {
      this.checkAllCheck(next, this.mallPayTypes.length, this, 'payTypesCheckAll');
    }
  }
  @Watch('selectMall.mallNo', {immediate: false, deep: true})
  mallNoChange() {
    if(this.theMalls.length > 1) {
      this.parterData = [];
      this.parterInputVal = '';
      this.getOrderOptionsOrderGrid.partnerNo = null;
      this.getDelaySummary();
      this.$nextTick(() => {
        if (this.searchTypeFlag) {
          this.handleSearchTypeArr();
        }
      });
    }
  }
  @Watch('parterInputVal', {immediate: true, deep: true})
  onInputValChange() {
    this.$nextTick(() => {
      this.dataFilter();
    });
  }
  @Watch('parterData', {immediate: true, deep: true})
  parterDataChange() {
    this.$nextTick(() => {
      this.dataFilter();
    });
  }
  @Watch('getOrderOptionsOrderGrid.claimStatusTypes.length', {immediate: false, deep: true})
  claimStatusTypesLength(next: number) {
    if (next) {
      this.checkAllCheck(next, this.claimStatusTypesArr.length, this, 'checkAllClaimStatusTypes');
    }
  }
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  @orderEnumsModule.Getter('payTypeMap')
  private readonly payTypeMap!: ValueNameType[];

  private startYmdt: string = addDay(new Date(), -7);
  private endYmdt: string = getToday();
  private PeriodOption = {
    name: 'startPeriod',
    periodTypes: ['td', 'ytd', '3d', '1w', '1m', '3m'],
    period: '1w'
  };
  private delaySummary: number = 0;
  private selectMall: any = {
    mallNo: undefined
  };
  private receiverArr: any[] = [
    {value: false, name: 'ORDER_ORDER_CONTENT_TOP_RECEIVER_SELECT_FALSE'},
    {value: true, name: 'ORDER_ORDER_CONTENT_TOP_RECEIVER_SELECT_TRUE'}
  ];
  private receiverValue: any = {
    value: undefined
  };
  private platformTypesCheckAll: boolean = true;
  private orderStatusTypesCheckAll: boolean = true;
  private showHelpDetail: boolean = false;
  private checkAllClaimStatusTypes: boolean = true;
  private initPlatformTypes: any[] = ['PC', 'MOBILE_WEB', 'MOBILE_APP'];
  private initOrderStatusTypes: any[] = [];

  private mallPayTypes: any[] = [];
  private mallInitPayTypes: any[] = [];
  private payTypesCheckAll: boolean = true;
  private theMalls: MallsArrItem[] = [];
  private getOrderOptionsOrderGrid: any = {
    mallNos: '',
    orderRegisterType: undefined,
    holdByReservation: false,
    includeReservation: true,
    memberGroupNo: undefined,
    searchType: 'ALL',
    keyword: '',
    platformTypes: ['PC', 'MOBILE_WEB', 'MOBILE_APP'],
    orderStatusTypes: [],
    payTypes: [],
    deliveryType: undefined,
    shippingAreaType: undefined, //缺少枚举类型
    includeHoldDelivery: this.includeHoldDelivery,
    returnWayType: '',
    claimStatusTypes: [],
    taskMessageSearchType: 'ALL',
    includeRecommender: true,
    startYmd: '',
    endYmd: '',
    searchDateType: 'STATE_CHANGE_YMDT',
    partnerNo: '',
    delay: false,
    page: 1,
    size: 30,
    receiverInputLater: ''// 배송 나중 입력
  };
  private orderRegisterTypes: any[] = [
    {value: 'NORMAL', name: 'ORDER_ORDER_CONTENT_TOP_ORDER_REGISTER_NORMAL'},
    {value: 'ADMIN', name: 'ORDER_ORDER_CONTENT_TOP_ORDER_REGISTER_ADMIN'},
    {value: 'ARIEL', name: 'ORDER_ORDER_CONTENT_TOP_ORDER_REGISTER_ARIEL'},
    {value: 'RECURRING_PAYMENT', name: 'ORDER_ORDER_CONTENT_TOP_ORDER_REGISTER_RECURRING_PAYMENT'}
  ];
  private deliveryTypeArr: any[] = [
    {
      value: 'PARCEL_DELIVERY',
      name: this.$route.path === '/order/list/pay-fail' ? 'ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_PARTNER_SHIPPING_AREA' : 'ORDER_ORDER_CONTENT_TOP_DELIVERY_TYPE_PARCEL_DELIVERY'
    },
    {
      value: 'DIRECT_DELIVERY',
      name: this.$route.path === '/order/list/pay-fail' ? 'ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_MALL_SHIPPING_AREA' : 'ORDER_ORDER_CONTENT_TOP_DELIVERY_TYPE_DIRECT_DELIVERY'
    }
  ];

  private shippingAreaTypeArr: any[] = [
    {value: 'PARTNER_SHIPPING_AREA', name: 'ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_PARTNER_SHIPPING_AREA'},
    {value: 'MALL_SHIPPING_AREA', name: 'ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_MALL_SHIPPING_AREA'}
  ];
  private returnWayTypeArr: any[] = [
    {value: '', name: 'ORDER_ORDER_CONTENT_TOP_RETURN_WAY_TYPE_ALL'},
    {value: 'SELLER_COLLECT', name: 'ORDER_ORDER_CONTENT_TOP_RETURN_WAY_TYPE_SELLER_COLLECT'},
    {value: 'BUYER_DIRECT_RETURN', name: 'ORDER_ORDER_CONTENT_TOP_RETURN_WAY_TYPE_BUYER_DIRECT_RETURN'}
  ];
  private claimStatusTypesValue: any = {
    value: undefined
  };
  private claimStatusTypesArr: any[] = [
    {value: 'CANCEL', name: 'ORDER_ORDER_CONTENT_TOP_CLAIM_STATUS_TYPE_CANCEL_DONE'},
    {value: 'RETURN', name: 'ORDER_ORDER_CONTENT_TOP_CLAIM_STATUS_TYPE_RETURN_DONE'},
    {value: 'EXCHANGE', name: 'ORDER_ORDER_CONTENT_TOP_CLAIM_STATUS_TYPE_EXCHANGE_DONE'}
  ];
  private refundsStatusTypesArr: any[] = [
    {value: 'REQUEST', name: 'ORDER_ORDER_CONTENT_TOP_REFUNDS_TYPE_REQUEST'},
    {value: 'DONE', name: 'ORDER_ORDER_CONTENT_TOP_REFUNDS_TYPE_DONE'},
    {value: 'WAITING', name: 'ORDER_ORDER_CONTENT_TOP_REFUNDS_TYPE_WAITING'}
  ];

  private taskMessageSearchTypeArr: any[] = [
    {value: 'ALL', name: 'ORDER_ORDER_CONTENT_TOP_ALL'},
    {value: 'PROCESSING', name: 'ORDER_ORDER_CONTENT_TOP_TASK_MESSAGE_SEARCH_TYPE_PROCESSING'},
    {value: 'DONE', name: 'ORDER_ORDER_CONTENT_TOP_TASK_MESSAGE_SEARCH_TYPE_DONE'},
    {value: 'PROCESSING_DONE', name: 'ORDER_ORDER_CONTENT_TOP_TASK_MESSAGE_SEARCH_TYPE_PROCESSING_DONE'}
  ];
  private initClaimStatusTypes: any[] = [];
  private mallNOsArr: any[] = [];
  private initMallNos: any = '';
  private parterSearchResult: any[] = [];
  private parterInputVal: any = '';
  private parterData: any[] = [];
  private selectedIdx = -1;
  private showSearch: boolean = false;
  private memberGroupArr: any[] = [];
  private searchTypeVal: any = {
    value: 'ALL'
  };
  private searchTypeArr: any[] = [];
  private searchTypeArrInit: any[] = [];
  private searchTypeFlag: boolean = false;
  private mallSelectDisabled: boolean = false;
  private allPayTypesArr: any = [];

  private get isNeededExchangeReleaseStatus(): boolean {
    return !['OrderPayFail', 'OrderHoldDelivery', 'OrderHoldByReservation'].includes(this.$route.name);
  }

  private exchangeTypes:SelectBoxOption<null|boolean>[]=[
      {value: true, name: 'Y'},
      {value: false, name: 'N'}
  ];

  private getOrderListNm(name) {
    switch (name) {
      case 'OrderList': // 전체주문
      case 'OrderHoldDelivery': // 배송보류
      case 'OrderHoldByReservation': // 예약주문
        return 'DEPOSIT_WAIT'; // 미지원

      case 'OrderListDeposit':
        return 'DEPOSIT_WAIT';

      case 'OrderPayDone':
        return 'PAY_DONE'

      case 'OrderProductPrepare':
        return 'PRODUCT_PREPARE'

      case 'OrderDeliveryPrepare':
        return 'DELIVERY_PREPARE'

      case 'Deliverying':
        return 'ORDER_DELIVERY_ING_GRID'

      case 'DeliveryDone':
        return 'DELIVERY_DONE'

      case 'OrderBuyConfirm':
        return 'BUY_CONFIRM'

      case 'OrderPayFail':
        return 'PAY_FAIL'
    }
  }

  private created(): void {
    this.getTheMalls();
    this.initOrderStatusTypes = this.orderStatusArr
        ? [...this.orderStatusArr]
        : ['DEPOSIT_WAIT', 'PAY_DONE', 'PRODUCT_PREPARE', 'DELIVERY_PREPARE', 'DELIVERY_ING', 'DELIVERY_DONE', 'BUY_CONFIRM', 'REFUND_DONE'];
    this.getOrderOptionsOrderGrid.orderStatusTypes = this.orderStatusArr
        ? [...this.orderStatusArr]
        : ['DEPOSIT_WAIT', 'PAY_DONE', 'PRODUCT_PREPARE', 'DELIVERY_PREPARE', 'DELIVERY_ING', 'DELIVERY_DONE', 'BUY_CONFIRM', 'REFUND_DONE'];
    this.searchDelayWhenComeFromMain()
  }
  private beforeMount() {
    this.changeSearchDateTypeArrFun();
  }
  private mounted(): void {
    this.initDataEmit();
    this.getDelaySummary();
    this.handleSearchTypeArr();
  }

  private searchDelayWhenComeFromMain(){
    if(this.$route.query.delay){
      this.handleDelaySearch()
    }
  }

  private handleMallNoChange(): void {
    this.getMemberGroups();
    if (this.selectMall.mallNo) {
      this.getPayTypes(false);
    } else {
      this.getPayTypes(true);
    }
    this.$emit('changeMallNo', {mallNo: this.selectMall.mallNo})
  }
  private handleSearchTypeArr(): void {
    this.searchTypeArr = [];
    let label = this.$route.name;
    let request: getOrdersSearchTypesRequest = {
      params: {
        groupByKey: '',
        orderStatus: this.getOrderListNm(label)
      }
    };
    this.$api.getOrdersSearchTypes(request).then((res: any) => {
      this.searchTypeArrInit = res.data.types;
      this.handleSearchType();
      this.searchTypeFlag = true;
    });
  }
  private handleSearchType(): void {
    if (this.searchTypeArrInit.length === 0) {
      return;
    }
    this.searchTypeArrInit.forEach(ele => {
      this.searchTypeArr.push({
        name: ele.name,
        value: ele.value
      });
    });
  }

  private handleDelaySearch(): void {
    this.initSearch();
    this.getOrderOptionsOrderGrid.delay = true;
    let data: any = {...this.getOrderOptionsOrderGrid};
    this.$emit('searchClick', data);
  }
  private getAllPayTypes(): void {
    let payTypesRequest: any = {
      params: {
        mallNos: ''
      }
    };
    payTypesRequest.params.mallNos = this.mallNOsArr.join(',');
    this.$api.getOrderConfigsOrder(payTypesRequest).then((res: any): any => {
      this.allPayTypesArr = [];
      this.allPayTypesArr = res.data;
      this.mallPayTypes = [];
      this.mallPayTypes = this.formatterPayTypes(res.data, true);
      this.filterPayTypes();
    });
  }
  private getPayTypes(init: boolean) {
    this.mallPayTypes = [];
    this.mallPayTypes = this.formatterPayTypes(this.allPayTypesArr, init);
    this.filterPayTypes();
  }
  private formatterPayTypes(data: any, init: boolean): any {
    if (data.length === 0) {
      return;
    }
    if (!init) {
      let typesArr: any = [];
      typesArr = data.filter((item: any): any => {
        return item.mallNo === this.selectMall.mallNo;
      })[0].value.enablePayTypes;
      return typesArr;
    } else {
      let typesArr: any = [];
      data.forEach((item: any): any => {
        if (item.value.enablePayTypes.length === 0) {
          return;
        }
        item.value.enablePayTypes.forEach((pay: any): any => {
          if (typesArr.indexOf(pay) < 0) {
            typesArr.push(pay);
          }
        });
        if (this.$route.name !== 'OrderHoldByReservation') {
          typesArr.push('RENTAL');
        }
      });
      return typesArr;
    }
  }
  private getMemberGroups(): void {
    this.getOrderOptionsOrderGrid.memberGroupNo = undefined;
    this.memberGroupArr = [];
    if (this.selectMall.mallNo) {
      let params = {
        mallNo: this.selectMall.mallNo
      };
      $('#loading').show();
      this.$api
          .getMemberGroups({params})
          .then(({data}): any => {
            this.memberGroupArr = data;
          })
          .finally((): any => {
            $('#loading').hide();
          });
    }
  }
  private resetPartner(): void {
    this.parterInputVal = '';
    this.getOrderOptionsOrderGrid.partnerNo = null;
  }
  private outsideClick(): void {
    this.showSearch = false;
  }
  private handleSearchBlur(): void {
    if (this.parterData.length && this.parterInputVal.length) {
      if (!this.parterData.find((item: any): any => item.partnerName === this.parterInputVal)) {
        this.parterInputVal = '';
        this.getOrderOptionsOrderGrid.partnerNo = null;
      }
    }
  }
  private handleParterSearch() {
    if (this.parterData.length === 0) {
      let parterRequest: GetMallsContractedPartnersByMallNoRequest = {
        pathParams: {
          mallNo: this.selectMall.mallNo
        }
      };
      $('#loading').show();
      this.$api
          .getMallsContractedPartnersByMallNo(parterRequest)
          .then(({data}): any => {
            this.parterData = data.filter(item => {
              return item.partnerStatus === 'ACTIVE' && ( item.contractStatus === 'ACTIVE' || item.contractStatus === 'SUSPEND' );
            });
            this.showSearch = true;
          })
          .finally((): any => {
            $('#loading').hide();
          });
    } else {
      this.showSearch = true;
    }
  }
  private itemClick(item: any) {
    if (item.value !== '0') {
      this.showSearch = false;
      this.parterInputVal = item.text;
      this.getOrderOptionsOrderGrid.partnerNo = item.value;
    }
  }

  private pressDown() {
    if (this.selectedIdx < this.parterSearchResult.length - 1) {
      this.selectedIdx++;
    } else {
      this.selectedIdx = 0;
    }
  }

  private pressUp() {
    if (this.selectedIdx === 0 || this.selectedIdx === -1) {
      this.selectedIdx = this.parterSearchResult.length - 1;
    } else {
      this.selectedIdx--;
    }
  }

  private pressEnter() {
    if (this.selectedIdx === -1) {
      return;
    }
    const result = this.parterSearchResult[this.selectedIdx];
    if (result.value !== '0') {
      this.showSearch = false;
      this.getOrderOptionsOrderGrid.partnerNo = result.value;
      this.parterInputVal = result.text;
      this.selectedIdx = -1;
    }
  }
  private dataFilter(): void {
    if (this.parterInputVal.length > 0) {
      const regexp = new RegExp(this.parterInputVal.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'gi');
      const result = this.parterData.filter((item: any) => {
        return item.partnerName.match(regexp);
      });
      if (result.length) {
        this.parterSearchResult = result.map(list => {
          return {
            text: list.partnerName,
            value: list.partnerNo,
            label: list.partnerName.replace(regexp, '<span>$&</span>')
          };
        });
      } else {
        let noSearchText: any = this.$t('ORDER_ORDER_CONTENT_TOP_PARTNER_SEARCH_NO_LABEL');
        this.parterSearchResult = [{value: '0', label: noSearchText, text: ''}];
      }
    } else {
      let noSearchText: any = this.$t('ORDER_ORDER_CONTENT_TOP_PARTNER_SEARCH_NO_LABEL');
      this.parterSearchResult = [{value: '0', label: noSearchText, text: ''}];
    }
  }

  // 배송지 입력
  private handleReceiverInputLater() {
    if (this.receiverValue.value !== undefined) {
      this.getOrderOptionsOrderGrid.receiverInputLater = this.receiverValue.value;
    } else {
      delete this.getOrderOptionsOrderGrid.receiverInputLater;
    }
  }

  //之后查看
  private handleClaimStatusTypes(): void {
    if (this.claimStatusTypesValue.value === undefined) {
      this.getOrderOptionsOrderGrid.claimStatusTypes = this.initClaimStatusTypes;
      return;
    }
    this.getOrderOptionsOrderGrid.claimStatusTypes = [];
    if (this.claimStatusTypesValue.value === 'CANCEL') {
      this.getOrderOptionsOrderGrid.claimStatusTypes = ['CANCEL_NO_REFUND', 'CANCEL_REQUEST', 'CANCEL_PROC_REQUEST_REFUND', 'CANCEL_PROC_WAITING_REFUND', 'CANCEL_DONE'];
    } else if (this.claimStatusTypesValue.value === 'RETURN') {
      this.getOrderOptionsOrderGrid.claimStatusTypes = [
        'RETURN_REQUEST',
        'RETURN_REJECT_REQUEST',
        'RETURN_PROC_BEFORE_RECEIVE',
        'RETURN_PROC_REQUEST_REFUND',
        'RETURN_PROC_WAITING_REFUND',
        'RETURN_DONE'
      ];
    } else if (this.claimStatusTypesValue.value === 'EXCHANGE') {
      this.getOrderOptionsOrderGrid.claimStatusTypes = [
        'EXCHANGE_REQUEST',
        'EXCHANGE_REJECT_REQUEST',
        'EXCHANGE_PROC_BEFORE_RECEIVE',
        'EXCHANGE_PROC_REQUEST_PAY',
        'EXCHANGE_PROC_WAITING_PAY',
        'EXCHANGE_DONE_PAY_DONE',
        'EXCHANGE_PROC_REQUEST_REFUND',
        'EXCHANGE_PROC_WAITING_REFUND',
        'EXCHANGE_DONE_REFUND_DONE',
        'EXCHANGE_DONE'
      ];
    }
  }
  private filterPayTypes(): void {
    this.payTypesCheckAll = true;
    this.handleCheckAll(this.payTypesCheckAll, this.getOrderOptionsOrderGrid, 'payTypes', this.mallPayTypes);
    this.mallInitPayTypes = this.payTypeMap.filter((item: any) => {
      return this.mallPayTypes.indexOf(item.value) > -1;
    });
  }

  private handlePlatformTypesCheckAll(): void {
    if (this.platformTypesCheckAll) {
      this.getOrderOptionsOrderGrid.platformTypes = [];
      this.getOrderOptionsOrderGrid.platformTypes = [...this.initPlatformTypes];
    } else {
      this.getOrderOptionsOrderGrid.platformTypes = [];
    }
  }
  private handleCheckAll(flag: boolean, tag: any, key: string, initarr: any, isValue: boolean = false): void {
    if (flag && !isValue) {
      tag[key] = [];
      tag[key] = [...initarr];
    } else if (flag && isValue) {
      tag[key] = [];
      initarr.map((item: any) => {
        tag[key].push(item.value);
      });
    } else {
      tag[key] = [];
    }
  }
  private checkAllCheck(e: number, num: number, checkAll: any, key: string): void {
    if (e === num) {
      checkAll[key] = true;
    } else {
      checkAll[key] = false;
    }
  }
  private getTheMalls() {
    let resArr = this.malls.map(item => {
      this.mallNOsArr.push(item.mallNo);
      return {option: item.mallName, value: item.mallNo};
    });
    this.theMalls = [...resArr];
    this.selectMall.mallNo = this.theMalls[0].value;
    if (this.theMalls.length === 1) {
      this.mallSelectDisabled = true;
    } else {
      this.mallSelectDisabled = false;
    }
    this.getMemberGroups();
    this.getOrderOptionsOrderGrid.mallNos = this.mallNOsArr.join(',');
    this.initMallNos = this.mallNOsArr.join(',');
    this.getAllPayTypes();
  }

  private whetherMoreThanThreeMonths(start, end) {
    let whether = true;
    let endDay = end.split('-') as any;
    let startDay = start.split('-') as any;
    if (parseInt(endDay[0]) === parseInt(startDay[0])) {
      if (parseInt(endDay[1]) - parseInt(startDay[1]) > 3) {
        whether = false;
      } else if (parseInt(endDay[1]) - parseInt(startDay[1]) === 3) {
        if (parseInt(endDay[2]) - parseInt(startDay[2]) > 0) {
          whether = false;
        }
      }
    } else {
      if (parseInt(endDay[0]) - parseInt(startDay[0]) > 1) {
        whether = false;
      } else {
        if (parseInt(startDay[1]) + 3 - parseInt(endDay[1]) < 12) {
          whether = false;
        } else {
          if (parseInt(endDay[2]) - parseInt(startDay[2]) > 0) {
            whether = false;
          }
        }
      }
    }
    return whether;
  }
  private handleSearch(event?): void {
    if (event.isComposing || event.keyCode === 229)  return;
    this.initSearch();
    this.getOrderOptionsOrderGrid.delay = false;

    const query = this.$route.query;
    query['dataRefresh'] = Date.now().toString();

    this.$router
      .replace(this.$route.path)
      .then(({ query }) => {
          delete query['dataRefresh'];
        });

    if (this.$route.path === '/order/list/pay-fail') {
      if (!this.whetherMoreThanThreeMonths(this.startYmdt, this.endYmdt)) {
        alert('조회기간은 최대 3개월까지 가능합니다. ');
        return;
      }
    }

    this.getOrderOptionsOrderGrid.delay = false;
    let data: any = {...this.getOrderOptionsOrderGrid};
    if(this.payTypesCheckAll) {
      data.payTypes = ''
    }
    if (data.platformTypes.length === 0) {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_PLATFORM_TYPE_EMPTY_ALERT'));
      return;
    }
    if (data.orderStatusTypes.length === 0) {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_ORDER_STATUS_TYPE_EMPTY_ALERT'));
      return;
    }
    this.$emit('searchClick', data);
  }
  private initDataEmit(): void {
    this.checkQueryAndSetRequest()
    this.initSearch();
    let data: any = {...this.getOrderOptionsOrderGrid};
    this.$emit('initRequest', data);
  }
  async checkQueryAndSetRequest(){
    if (this.$route.query.fromMain) {
      const period =  (this.$refs.dateCalendar as any).clickPeriod('1m');

      this.getOrderOptionsOrderGrid.startYmd = period.start;
      this.getOrderOptionsOrderGrid.endYmd = period.end;

      // grid가 로드 되어 있는 상태가 아니라 $nextTick 실행
      this.$nextTick(()=>{this.handleSearch();})
    }
  }
  private handleCancel(): void {
    let init: any = {
      mallNos: '',
      orderRegisterType: undefined,
      holdByReservation: false,
      includeReservation: true,
      memberGroupNo: undefined,
      searchType: 'ALL',
      keyword: '',
      platformTypes: ['PC', 'MOBILE_WEB', 'MOBILE_APP'],
      orderStatusTypes: this.orderStatusArr
          ? [...this.orderStatusArr]
          : ['DEPOSIT_WAIT', 'PAY_DONE', 'PRODUCT_PREPARE', 'DELIVERY_PREPARE', 'DELIVERY_ING', 'DELIVERY_DONE', 'BUY_CONFIRM', 'REFUND_DONE'],
      payTypes: [],
      deliveryType: undefined,
      shippingAreaType: undefined, //缺少枚举类型
      includeHoldDelivery: this.includeHoldDelivery,
      returnWayType: '',
      claimStatusTypes: [
        'CANCEL_NO_REFUND',
        'CANCEL_REQUEST',
        'CANCEL_PROC_REQUEST_REFUND',
        'CANCEL_PROC_WAITING_REFUND',
        'CANCEL_DONE',
        'RETURN_REQUEST',
        'RETURN_REJECT_REQUEST',
        'RETURN_PROC_BEFORE_RECEIVE',
        'RETURN_PROC_REQUEST_REFUND',
        'RETURN_PROC_WAITING_REFUND',
        'RETURN_DONE',
        'EXCHANGE_REQUEST',
        'EXCHANGE_REJECT_REQUEST',
        'EXCHANGE_PROC_BEFORE_RECEIVE',
        'EXCHANGE_PROC_REQUEST_PAY',
        'EXCHANGE_PROC_WAITING_PAY',
        'EXCHANGE_DONE_PAY_DONE',
        'EXCHANGE_PROC_REQUEST_REFUND',
        'EXCHANGE_PROC_WAITING_REFUND',
        'EXCHANGE_DONE_REFUND_DONE',
        'EXCHANGE_DONE'
      ],
      taskMessageSearchType: 'ALL',
      includeRecommender: true,
      startYmd: '',
      endYmd: '',
      searchDateType: this.searchDateTypeArr[0].value,
      partnerNo: 0,
      page: 1,
      size: 30
    };
    if (this.theMalls.length === 1) {
      this.selectMall.mallNo = this.theMalls[0].value;
      this.mallSelectDisabled = true;
      this.handleMallNoChange();
    } else {
      this.mallSelectDisabled = false;
      this.selectMall.mallNo = undefined;
    }
    this.memberGroupArr = [];
    this.claimStatusTypesValue.value = undefined;
    (this.$refs.dateCalendar as any).clickPeriod('1w');
    this.getOrderOptionsOrderGrid = init;
    this.searchTypeVal.value = 'ALL';
    this.getPayTypes(true);
    this.changeSearchDateTypeArrFun();
    this.$emit('cancelClick');
  }
  private initSearch(): void {
    this.getOrderOptionsOrderGrid.startYmd = this.startYmdt;
    this.getOrderOptionsOrderGrid.endYmd = this.endYmdt;
    if (this.selectMall.mallNo) {
      this.getOrderOptionsOrderGrid.mallNos = this.selectMall.mallNo;
    } else {
      this.getOrderOptionsOrderGrid.mallNos = this.mallNOsArr.join(',');
    }
    this.getOrderOptionsOrderGrid.searchType = this.searchTypeVal.value;

    if (this.showClaimType) {
      this.getOrderOptionsOrderGrid.claimType = this.claimStatusTypesValue.value;
    }
  }
  private changeSearchDateTypeArrFun() {
    this.getOrderOptionsOrderGrid.searchDateType = this.searchDateTypeArr[0].value;
  }
  private getDelaySummary(): void {
    let label = this.$route.name;
    if (this.showDelay) {
      if(label === 'DeliveryPrepare') {
        const delaySummaryRequest: GetOrderOptionsNaverDelaySummaryRequest = {
          params: {
            mallNos: this.selectMall.mallNo || this.initMallNos,
          }
        };
        this.$api.getOrderOptionsNaverDelaySummary(delaySummaryRequest).then(res => {
          this.delaySummary = res.data.delayCount;
        });
      } else if(label === 'OrderProductPrepare'){
        const delaySummaryRequest: GetOrderOptionsMallDelaySummaryRequest = {
          params: {
            mallNos: this.selectMall.mallNo || this.initMallNos,
            orderStatusTypes: this.delayOrderType
          }
        };
        this.$api.getOrderOptionsMallDelaySummary(delaySummaryRequest).then(res => {
          this.delaySummary = res.data.delayCount;
        });
      }
    }
  }
}
